module.exports = __webpack_public_path__ + "static/img/barrie3.bb02e71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/barrie3.jpg
// module id = 71
// module chunks = 9